import { MetricUId } from "../../Metrics/constants"
import getChartConfigTemplate from "../Templates/PieChart/utils"
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.PENDING_PROJECT_REQUESTS]: "#F76B15",
  [MetricUId.ACCEPTED_PROJECT_REQUESTS]: "#0969DA",
  [MetricUId.WITHDRAWN_PROJECT_REQUESTS]: "#D0D6DB",
  [MetricUId.REJECTED_PROJECT_REQUESTS]: "#E54D2E",
  [MetricUId.CLOSED_PROJECT_REQUESTS]: "#8E4EC6"
}

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.PENDING_PROJECT_REQUESTS, MetricUId.ACCEPTED_PROJECT_REQUESTS, MetricUId.WITHDRAWN_PROJECT_REQUESTS, MetricUId.REJECTED_PROJECT_REQUESTS, MetricUId.CLOSED_PROJECT_REQUESTS],
    subTitleMetricUid: MetricUId.TOTAL_PROJECT_REQUESTS,
    exportFileName: props.name,
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;